import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardCheck, Camera } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Layout from '../common/Layout';

const EvaluationOptionsScreen: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <Layout title={t('home.questionnaire.title')} showBackButton={true}>
      <div className="flex flex-col items-center pt-8 pb-12">
        <p className="text-gray-600 text-center mb-10 max-w-xs">
          {t('home.questionnaire.description')}
        </p>
        
        <div className="w-full space-y-6 animate-slide-up">
          <button 
            onClick={() => navigate('/questionnaire')}
            className="w-full card-shadow flex items-center p-6 bg-white rounded-xl border border-gray-100 hover:border-sangre-200 transition-all duration-300 active:scale-98 group"
          >
            <div className="bg-sangre-50 p-4 rounded-full group-hover:bg-sangre-100 transition-colors duration-300">
              <ClipboardCheck className="w-8 h-8 text-sangre-600" />
            </div>
            <div className="ml-4 text-left">
              <h3 className="font-medium text-gray-900 text-lg">{t('home.questionnaire.title')}</h3>
              <p className="text-gray-500 text-sm">{t('home.questionnaire.description')}</p>
            </div>
          </button>
          
          <button 
            onClick={() => navigate('/photo-evaluation')}
            className="w-full card-shadow flex items-center p-6 bg-white rounded-xl border border-gray-100 hover:border-fuerte-200 transition-all duration-300 active:scale-98 group"
          >
            <div className="bg-fuerte-50 p-4 rounded-full group-hover:bg-fuerte-100 transition-colors duration-300">
              <Camera className="w-8 h-8 text-fuerte-600" />
            </div>
            <div className="ml-4 text-left">
              <h3 className="font-medium text-gray-900 text-lg">{t('home.photoEvaluation.title')}</h3>
              <p className="text-gray-500 text-sm">{t('home.photoEvaluation.description')}</p>
            </div>
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default EvaluationOptionsScreen;
